/**
 * Announces a message to screen readers through the page's shared live region.
 *
 * WHY THIS EXISTS. Everything on this site reports success and failure with a toast, and a toast is
 * a purely visual event — it appears, it fades, and a screen reader is told nothing. Saving a
 * collection has no other visible outcome on the page it happens from, so without this a member
 * using a screen reader presses the button and receives silence.
 *
 * The region lives in `_Layout.cshtml` next to the React modal host, so one exists on every page
 * and no component has to render its own.
 */

const LIVE_REGION_ID = "a11y-status";

/**
 * @param {string} message Plain text. Anything with markup belongs in the toast, not here.
 */
export function announce(message) {
  if (!message) return;

  const region = document.getElementById(LIVE_REGION_ID);
  if (!region) return;

  // Clear first, then set on the next frame. An assistive technology announces a live region when
  // its contents CHANGE, so writing the same string twice in a row - "Saved 8 colours" after
  // saving the same collection again - would be silent without this.
  region.textContent = "";

  window.requestAnimationFrame(() => {
    region.textContent = message;
  });
}
